import { render, staticRenderFns } from "./ConsumosPorItem.vue?vue&type=template&id=2e102dce"
import script from "./ConsumosPorItem.vue?vue&type=script&lang=js"
export * from "./ConsumosPorItem.vue?vue&type=script&lang=js"
import style0 from "./ConsumosPorItem.vue?vue&type=style&index=0&id=2e102dce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports